import config from '@/config';
import type { AppModule } from '@/config/maintenanceModules';
import { useDeploymentSettingsStore } from '@/stores/deploymentSettings';
import { canAccessCapsulePhilipsModule } from '@/utils/capsulePhilipsAccess';

/** Modules that only administrators (userType 1) may access. */
export const ADMIN_ONLY_MODULES: AppModule[] = ['mp1-data-analyzer'];

export function canAccessAdminOnlyModule(
    module: AppModule,
    userType: number
): boolean {
    if (!ADMIN_ONLY_MODULES.includes(module)) {
        return true;
    }
    return userType === config.userType.admin;
}

export function canUserAccessModuleFully(
    module: AppModule,
    userType: number,
    email: string | undefined,
    deploymentStore: ReturnType<typeof useDeploymentSettingsStore>
): boolean {
    if (!canAccessAdminOnlyModule(module, userType)) {
        return false;
    }
    if (!deploymentStore.canUserAccessModule(module, userType, email)) {
        return false;
    }
    return canAccessCapsulePhilipsModule(module, email);
}
